<template>
  <div>
    <div>
      <van-nav-bar :title="$t('video.video')">
        <template #right>
          <van-icon name="chat-o" size="24" color="#fff" @click="toLogin('/ServiceOnline')" />
        </template>
      </van-nav-bar>
    </div>
    <!-- Tab已注释，默认显示最新数据 -->
    <!--<div>
      <van-tabs
        v-model="active"
        title-inactive-color="rgb(68, 40, 137)"
        title-active-color="rgb(197, 113, 207)"
        line-height="10px"
        line-width="40px"
        @change="onChange"
      >
        <van-tab
          :title="item.name"
          :name="item.id"
          title-style="font-size:16px;line-height:50px;"
          v-for="(item,index) in videolitem"
          :key="item.id"
          @click="toPlayVideo(item.id)"
        >
        <template #title v-if="index==0">
          <div style="display: flex">
            <div style="">{{ item.name }}</div>
            <div style="color: rgb(197, 113, 207);font-weight: bold;background: url('/img/new.png') right  top 5px / 100% no-repeat;width: 30px;">
          </div>
          </div>
        </template>
          <div>
            <van-pull-refresh
              v-model="refreshing"
              @refresh="onRefresh"
              :pulling-text="$t('video.pull_down')"
              :loosing-text="$t('video.release')"
              :loading-text="$t('video.refreshing')"
            >
              <van-list
                v-model="loading"
                :finished="finished"
                :loading-text="$t('video.loading')"
                :finished-text="$t('video.no_more')"
                @load="onLoad"
              >
                <div class="list-item">
                  <div class="movie-list-item" v-for="(i,key) in data" :key="key" @click="toPlayVideo(i.id)">
                    <div
                      class="cover_img van-image van-image--round"
                      style="width: 100%; height: 100px;"
                    >
                      <img
                        :src="i.vod_pic"
                        class="van-image__img"
                      />
                    </div>
                    <div class="movie-list-item-bottom" style="bottom: 33px;">
                      <div class="movie-time-div">
                        <span
                          >{{ i.vod_name }}</span
                        ><span style="font-size: 12px;">{{$t("video.play")}} :{{ i.count }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>-->

    <!-- 默认显示最新视频数据 -->
    <div>
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        :pulling-text="$t('video.pull_down')"
        :loosing-text="$t('video.release')"
        :loading-text="$t('video.refreshing')"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :loading-text="$t('video.loading')"
          :finished-text="$t('video.no_more')"
          @load="onLoad"
        >
          <div class="list-item">
            <div class="movie-list-item" v-for="(i,key) in data" :key="key" @click="toPlayVideo(i.id)">
              <div
                class="cover_img van-image van-image--round"
                style="width: 100%; height: 100px;"
              >
                <img
                  :src="i.vod_pic"
                  class="van-image__img"
                />
              </div>
              <div class="movie-list-item-bottom" style="bottom: 33px;">
                    <div class="movie-time-div">
                      <span v-if="shouldShowPlayCount(i.count)" style="font-size: 12px;">{{$t("video.play")}} :{{ i.count }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div style="height: 55px;"></div>
  </div>
</template>
<script>
import { isVideoSourceAvailable } from '../../common/videoSource';
import { getDisplayPlayCount } from '../../common/videoPlayCount';

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      // videolitem: [], // 已注释，不再需要Tab列表
      data: [],
      page: 1,
      id: 888, // 固定为888（最新）
      randomSeed: Math.floor(Math.random() * 2147483646) + 1,
    };
  },
  methods: {
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 1;
        this.data = [];
      }
      this.loading = true;
      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          this.$toast(this.$t("reservation.refresh"));
        }
      });
    },
    // Tab切换方法已注释（不再需要）
    /*
    onChange(name) {
      this.id = name;
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad(true);
    },
    */
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.randomSeed = Math.floor(Math.random() * 2147483646) + 1;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    shouldShowPlayCount(count) {
      const playCount = Number(count);
      return Number.isFinite(playCount) && playCount < 100000;
    },
    shuffleVideoItems(items) {
      const shuffledItems = items.slice();
      let seed = this.randomSeed;
      const random = () => {
        seed = (seed * 48271) % 2147483647;
        return seed / 2147483647;
      };

      for (let index = shuffledItems.length - 1; index > 0; index--) {
        const targetIndex = Math.floor(random() * (index + 1));
        [shuffledItems[index], shuffledItems[targetIndex]] = [
          shuffledItems[targetIndex],
          shuffledItems[index],
        ];
      }

      return shuffledItems;
    },
    async getVideoList() {
      const playableItems = [];
      let requestedPages = 0;

      try {
        // Some imported records point at video nodes that are completely offline.
        // Read ahead so each visible batch still contains playable entries.
        while (playableItems.length < 8 && requestedPages < 6 && !this.finished) {
          const res = await this.$http({
            method: 'get',
            data: {
              id: this.id,
              page: this.page,
              seed: this.randomSeed,
            },
            url: 'video_list',
          });
          const items = res.data && Array.isArray(res.data.data)
            ? res.data.data
            : [];

          requestedPages++;
          if (items.length === 0) {
            this.finished = true;
            break;
          }

          this.page++;
          playableItems.push(...items
            .filter((item) => isVideoSourceAvailable(item.vod_play_url, item.vod_status))
            .map((item) => ({
              ...item,
              count: getDisplayPlayCount(item.id, item.count),
            })));

          if (items.length < 8) {
            this.finished = true;
          }
        }

        this.data = this.data.concat(this.shuffleVideoItems(playableItems));
      } catch (error) {
        console.error('Error fetching video list:', error);
        throw error;
      }
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    // 获取视频分类方法已注释（不再需要Tab）
    /*
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        this.videolitem = res.data;
        const obj = { id: 888, name: "最新,new,最新の,new,жаңы" };
        this.videolitem.unshift(obj);

        // 根据当前语言选择对应的名称
        const langMap = {
          'zh': 0,
          'kr': 0,
          'en': 1,
          'ja': 2,
          'de': 3,
          'mn': 4
        };
        const currentLang = getCurrentLang();
        const langIndex = langMap[currentLang] || 0;
        this.videolitem.forEach((item) => {
          const parts = item.name.split(",");
          item.name = parts[langIndex] || parts[0];
        });
      });
    },
    */
  },
  created() {
    // getVideoClass(); // 已注释，不再需要加载分类Tab
  },
};
</script>
<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(30deg, #d51aac, #d63f8c);
}
/* Tab样式已注释 */
/*
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}
/deep/ .van-tabs__line {
  background-color: #c571cf;
}
*/
/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;
}
/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;
}
/deep/ .van-pull-refresh__head {
  height: 100px;
}
/deep/ .van-pull-refresh__text {
  font-size: 32px; /* 设置字体大小 */
  color: #000;
}
.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.movie-list-item {
  width: calc(50% - 16px);
  margin-bottom: 3vw;
}
.cover_img {
  border-radius: 20px;
}
.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}
.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
}
.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}
/* Tab激活样式已注释 */
/*
.activeBg{
  color: rgb(197, 113, 207);
    font-weight: bold;
    background: url('/img/new.png') right top 5px / 30% no-repeat;
}
*/
</style>

